import { getPasswordComplexity } from "@lib/helpers";

const CONFIG = {
  1: {
    message: "Foarte nesigura",
    backgroundColor: "bg-[#C00033]",
  },
  2: {
    message: "Nesigura",
    backgroundColor: "bg-[#FD0245]",
  },
  3: {
    message: "Siguranta medie",
    backgroundColor: "bg-[#F8B500]",
  },
  // 4: {
  //   message: "Sigura",
  //   backgroundColor: "bg-[#61DC00]",
  // },
  4: {
    message: "Foarte sigura",
    backgroundColor: "bg-[#319D10]",
  },
};

const CheckIcon = () => (
  <span className="text-[#319D10] text-[18px] font-medium">&#10003;</span>
);
const CrossIcon = () => (
  <span className="text-red-brand text-[18px] font-semibold">&#10005;</span>
);

const PasswordComplexity = ({ password }) => {
  const { score, cases } = getPasswordComplexity(password);

  return (
    <>
      <div className="w-full mb-[2px] flex space-x-[10px]">
        {Object.entries(CONFIG).map(([complexity, config], index) => (
          <div
            key={index}
            className={`h-[4px] rounded-[24px] w-[25%] ${
              score >= complexity ? config.backgroundColor : "bg-[#D8D8D8]"
            }`}
          ></div>
        ))}
      </div>

      <div className="text-[14px] font-medium mt-[6px]">
        Parola trebuie sa contina:
      </div>

      <ul className="text-[14px] text-[#979797] list-disc ml-[15px]">
        {Object.values(cases).map((caseItem, index) => (
          <li key={index}>
            {caseItem.description}{" "}
            {caseItem.isMet ? <CheckIcon /> : <CrossIcon />}
          </li>
        ))}
      </ul>
    </>
  );
};

export default PasswordComplexity;
